const initialState = () => {
  return {
    notification: {
      show: false,
      message: '',
      isError: false,
      timeout: 7
    }
  }
}

const state = initialState()

const actions = {
  showAlert ({ commit }, message) {
    commit('SHOW_ALERT', { message, isError: false })
  },
  showError ({ commit }, message) {
    commit('SHOW_ALERT', { message, isError: true })
  },
  resetAlert ({ commit }) {
    commit('HIDE_NOTIFICATION')
    setTimeout(() => commit('RESET_ALERT'), 400)
  }
}

const mutations = {
  SHOW_NOTIFICATION () {
    state.notification.show = true
  },

  HIDE_NOTIFICATION () {
    state.notification.show = false
  },

  SHOW_ALERT (state, { message, isError }) {
    state.notification.show = true
    state.notification.message = message
    state.notification.isError = isError
  },

  RESET_ALERT (state) {
    Object.assign(state, initialState())
  }
}

const getters = {
  show: state => state.notification.show,
  message: state => state.notification.message,
  isError: state => state.notification.isError,
  notificationTimeout: state => state.notification.timeout * 1000
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
